module.exports = {
  // TEMPORAL: imágenes del visor que reemplaza la vista interior 3D (ver interior.viewer.component.tsx).
  InteriorData: () => {
    return {
      "avatr7" : [
        require('../assets/images/avatr7/Full_Caramel_Luxe.jpg'),
        require('../assets/images/avatr7/interior-space.jpg'),
      ],
      "avatr11" : [
        require('../assets/images/avatr11/luxury-cockpit.jpg'),
        require('../assets/images/avatr11/luxury-seat_01.jpg'),
        require('../assets/images/avatr11/luxury-seat_02.jpg'),
      ],
    }
  }
}
